import { Injectable, Inject  } from "@angular/core";
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { IFormBehaviorPlan } from "../Models/Forms/IFormBehaviorPlan";
import { BaseService } from './BaseService';

@Injectable()
export class FormBehaviorPlanService  extends  BaseService {
  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string)
  {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormBehaviorPlan(id: number) {
    return this._http.get(this._baseUrl + "api/FormBehaviorPlan/" + id)
      .map((response: IFormBehaviorPlan) => response as IFormBehaviorPlan)
      .catch(this.errorHandler);
  }

  validateForm(id: number) {
    return this._http.get(this._baseUrl + "api/FormBehaviorPlan/ValidateForm" + id)
      .map((response: string[]) => response as string[])
      .catch(this.errorHandler)
  }

  insertUpdateFormBehaviorPlan(formBehaviorPlanDetails: IFormBehaviorPlan) {
    return this._http.post(this._baseUrl + 'api/FormBehaviorPlan', formBehaviorPlanDetails)
      .map((response: IFormBehaviorPlan) => response as IFormBehaviorPlan)
      .catch(this.errorHandler);
  }

  deleteBehaviorPlan(id) {
    return this._http.delete(this._baseUrl + "api/FormBehaviorPlan" + id)
      .map((response: IFormBehaviorPlan) => response as IFormBehaviorPlan)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }

}


